// accordion change bg color
let accordionItem = document.querySelectorAll('.accordion-item')
accordionItem.forEach((Item) => {
    Item.childNodes[1].addEventListener("click", (e) => {
        accordionItem.forEach((Element) => {
            Element.classList.remove("add-shadow")
        })
        Item.classList.contains("add-shadow") ? Item.classList.remove("add-shadow") : Item.classList.add("add-shadow");
    })
})

function updateSymbol(e) {
    var selected = $(".currency-selector option:selected");
    $(".currency-symbol").text(selected.data("symbol"));
    $(".currency-amount").prop("placeholder", selected.data("placeholder"));
    $(".currency-addon-fixed").text(selected.text());
}

$(".currency-selector").on("change", updateSymbol);

updateSymbol();


// custom dropdown with search

function create_custom_dropdowns() {
    $('.select-custom').each(function (i, select) {
        if (!$(this).next().hasClass('dropdown-select')) {
            $(this).after('<div class="dropdown-select wide ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
            var dropdown = $(this).next();
            var options = $(select).find('option');
            var selected = $(this).find('option:selected');
            dropdown.find('.current').html(selected.data('display-text') || selected.text());
            options.each(function (j, o) {
                var display = $(o).data('display-text') || '';
                dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '">' + $(o).text() + '</li>');
            });
        }
    });

    // $('.dropdown-select ul').before('<div class="dd-search"><input id="txtSearchValue" autocomplete="off" placeholder ="Type a city" onkeyup="filter()" class="dd-searchbox form-control custom-form-control" type="text"></div>');
}


$(document).ready(function () {
    create_custom_dropdowns();
});
// counter
// $('.digit-counting').each(function () {
//     var $this = $(this),
//         countTo = $this.attr('data-count');

//     $({ countNum: $this.text() }).animate({
//         countNum: countTo
//     },

//         {

//             duration: 3000,
//             easing: 'linear',
//             step: function () {
//                 $this.text(Math.floor(this.countNum));
//             },
//             complete: function () {
//                 $this.text(this.countNum);
//                 //alert('finished');
//             }

//         });


// });
// counter





